var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-35px 0 0 40px",
      "font-weight": "600"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle",
      "margin-top": "-2px"
    },
    attrs: {
      "src": require("../../../assets/icon/返回.png")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v("\n\t\t录入应收账款\n\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#fdfdfd",
      "padding": "30px 50px",
      "border": "1px solid #f7f7f7"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("组织架构：")]), _c('span', [_vm._v(_vm._s(_vm.$globals.group_name) + "/" + _vm._s(_vm.editList.organize_name))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("系列：")]), _c('span', [_vm._v(_vm._s(_vm.editList.series))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("业务板块：")]), _c('span', [_vm._v(_vm._s(_vm.editList.industry_andInnovation))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("项目名称：")]), _c('span', [_vm._v(_vm._s(_vm.editList.project_name))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("甲方开票名头：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.editList.party_title))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("我方开票名头：")]), _c('span', [_vm._v(_vm._s(_vm.editList.partner_abbreviation))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("已开发票金额：")]), _c('span', [_vm._v(_vm._s(_vm.editList.invoiced_amount))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("未开发票金额：")]), _c('span', [_vm._v(_vm._s(_vm.editList.not_invoiced_amount))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("应收款合计：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.editList.account_receivable_total))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 50px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("回款日期")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "format": "yyyy-MM-dd",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.condition.start_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "start_date", $$v)
      },
      expression: "condition.start_date"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "height": "41px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "3% 2% 0 2%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "350"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "period_service",
      "label": "服务期",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invoice_no",
      "label": "发票号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount_of_money",
      "label": "发票金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receivable_amount",
      "label": "应收金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "collection_time",
      "label": "回款时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "collection_amount",
      "label": "回款金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invoicing_date",
      "label": "开票日期",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remarks",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/icon/修改.png")
          },
          on: {
            "click": function($event) {
              return _vm.Revise(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "500px",
      "margin-top": "-20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改",
      "visible": _vm.showPlan,
      "width": "30%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showPlan = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "120px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "回款时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.plan.collection_time),
      callback: function($$v) {
        _vm.$set(_vm.plan, "collection_time", $$v)
      },
      expression: "plan.collection_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "回款金额"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入回款金额"
    },
    model: {
      value: (_vm.plan.collection_amount),
      callback: function($$v) {
        _vm.$set(_vm.plan, "collection_amount", $$v)
      },
      expression: "plan.collection_amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.plan.remarks),
      callback: function($$v) {
        _vm.$set(_vm.plan, "remarks", $$v)
      },
      expression: "plan.remarks"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.PlanSave()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "vertical-align": "middle",
      "margin-top": "-3px"
    },
    attrs: {
      "src": require("../../../assets/icon/录入应收账款.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-size": "18px",
      "font-weight": "600"
    }
  }, [_vm._v("应收账款信息")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89bf26d2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/receivable/Receivable/edit.vue
// module id = null
// module chunks = 